import MUIDataTable from "mui-datatables";
import { useState, useEffect } from "react";
import "../transaction/transaction.css"
import { getUserProfile } from "../../../../helpers/profile_helper";

const show_transaction_account_balance = process.env.REACT_APP_SHOW_TRANSACTION_ACCOUNT_BALANCE === "true"

const EasypayoutTransactionScreen = ({ selectedCompany, selectedAccount, apiService }) => {

  let [accountTransactionData, setAccountTransactionData] = useState([]);
  const [userProfile, setUserProfile] = useState({});
  const [avlblc, setAvlblc] = useState("");
  const [avlBalanceCrDr, setAvlBalanceCrDr] = useState("")
  const [acnumber, setAcnumber] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [tspBankAcNumber, setTspBankAcNumber] = useState("");
  const [bankAcBalance, setBankAcBalance] = useState("");
  const [bankAccountCrDr, setBankAccountCrDr] = useState("NA");
  const [companyApiKey, setCompanyApiKey] = useState("NA")
  const [accountLoadDataColumns, setAccountLoadDataColumns] = useState([
    {
      name: "stmt_timestamp",
      label: "Date",
      options: {
        filter: true,
        sort: true,
      },
    }, {
      name: "ledger_event",
      label: "Event",
      options: {
        filter: true,
        sort: true,
      },
    }, {
      name: "contact_name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "debit_amount",
      label: "Debit",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          if (value == "") {
            return "-"
          }
          return `₹ ${value}`;

        },
        setCellProps: (value) => ({ style: { color: "Red" } }),
      },
    }, {
      name: "credit_amount",
      label: "Credit",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          if (value == "") {
            return "-";
          }
          return `₹ ${value}`;
        },
        setCellProps: (value) => ({ style: { color: "Green" } }),
      },
    },
    {
      name: "closing_balance",
      label: "A/C Balance",
      opptions: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "utr",
      label: "UTR/RRN",
      options: {
        filter: true,
        sort: true,

      },
    },
    {
      name: "beneficiary_acno",
      label: "A/c No / UPI",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "ref",
      label: "ref",
      options: {
        filter: true,
        sort: false,
        setCellProps: (value) => ({ style: { paddingRight: "110px" } }),
      },
    },
  ]);
  var mui_table_options = {
    rowsPerPage: 10,
    selectableRows: 'none',
    downloadOptions: { filename: "Account Transaction", separator: "," }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedCompany || !selectedAccount) {
        setAvlblc("");
        setAvlBalanceCrDr("")
        setAcnumber("");
        setIfsc("");
        setAccountTransactionData([]);
        return;
      }
      setAvlblc("Loading ...");
      setAvlBalanceCrDr("NA")

      setIfsc("Loading ...")
      setAcnumber("Loading ...")
      setBankAcBalance("false")
      try {
        var user_profile = await getUserProfile();
        setUserProfile(user_profile);
        var response = await apiService({ method: "post", path: "/user/get_balance_and_latest_transactions", payload: { company: selectedCompany, account: selectedAccount } });
        // balance,
        // balance_cr_dr,
        // bank_balance,
        // bank_balance_cr_dr,
        // tsp_acocunt_no,
        // stmts: stmts,
        // van: { acc_no: virtual_account_number, ifsc },
        setAvlblc(response.data.balance);
        setAvlBalanceCrDr(response.data.balance_cr_dr)
        setAccountTransactionData(response.data.stmts);
        // console.log(response.data.stmts);
        setAcnumber(response.data.van.acc_no);
        setIfsc(response.data.van.ifsc);
        setTspBankAcNumber(response.data.tsp_acocunt_no);
        setBankAcBalance(response.data.bank_balance ? response.data.bank_balance : "false");
        setBankAccountCrDr(response.data.bank_balance_cr_dr);
        setCompanyApiKey(response.data.company_api_key)
      } catch (error) {
        localStorage.removeItem("user_profile");
        console.log("%o", error);
      }
    };

    fetchData();
  }, [selectedCompany, selectedAccount]);
  // ADD THIS FUNCTION HERE
  const copyApiKey = async () => {
    try {
      if (!companyApiKey || companyApiKey === "NA") return;
      await navigator.clipboard.writeText(companyApiKey);
      alert("API Key copied to clipboard");
    } catch (err) {
      console.error("Copy failed", err);
    }
  };
  return (
    <div className="Transaction-easypayouts-load-screen">
    
      <div className="Transaction-frame-parent4">
          <div className="Transaction-company-details-box">
        <div className="Transaction-company-title">Company Details</div>

        <div className="Transaction-company-api-row">
          <span className="Transaction-company-label">Company API Key :</span>
          <div className="Transaction-company-value api-key">
            {companyApiKey}
          </div>
          <button
            className="Transaction-copy-btn"
            onClick={copyApiKey}
            title="Copy API Key"
            type="button"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
          </button>
        </div>
      </div>
        <div className="Transaction-card-container">
          {show_transaction_account_balance && (
            <div className="Transaction-frame-parent5">
              <div className="Transaction-frame-parent6">
                <div className="Transaction-vector-container">
                  <img className="Transaction-vector-icon1" alt="" src="/vector.svg" />
                </div>
                <div className="Transaction-avaliable-balance-group">
                  <b className="Transaction-loads12">Available Balance</b>
                  <div className="Transaction-div20"> {avlBalanceCrDr != 'NA' ? (avlBalanceCrDr == "Dr" ? "- " : "+") : ""} ₹ {avlblc}</div>
                </div>
              </div>
              <div className="Transaction-cash-stack1" />
            </div>
          )}

          {/* <div className="Transaction-frame-parent5">
            <div className="Transaction-frame-parent6">
              <div className="Transaction-vector-container">
                <img className="Transaction-vector-icon2" alt="" src="/icon1.svg" />
              </div>
              <div className="Transaction-avaliable-balance-group">
                <b className="Transaction-loads12">Account Details</b>
                <div className="Transaction-div16">
                  <span className="Transaction-acifsc"> Ac.no :</span> {acnumber}
                </div>
                {ifsc &&(
                <div className="Transaction-div16">
                  <span className="Transaction-acifsc"> IFSC :</span> {ifsc}
                </div>)}
              </div>
            </div>
            <div className="Transaction-cash-stack1" />
          </div> */}
          {bankAcBalance != 'false' && (
            <div className="Transaction-frame-parent5">
              <div className="Transaction-frame-parent6">
                <div className="Transaction-vector-container">
                  <img className="Transaction-vector-icon2" alt="" src="/icon1.svg" />
                </div>
                <div className="Transaction-avaliable-balance-group">
                  <b className="Transaction-loads12">Bank  Details</b>
                  <div className="Transaction-div16">
                    <span className="Transaction-acifsc"> Bank Ac.no :</span> {tspBankAcNumber}
                  </div>
                  <div className="Transaction-div16">
                    <span className="Transaction-acifsc"> Bank Balance:</span> {bankAcBalance}
                  </div>
                </div>
              </div>
              <div className="Transaction-cash-stack1" />
            </div>

          )}
        </div>

        <div className="Transaction-table-content">
          <MUIDataTable
            title={"Latest Account Transactions"}
            data={accountTransactionData}
            columns={accountLoadDataColumns}
            options={mui_table_options}
          />
        </div>
      </div>
    </div>
  );
};

export default EasypayoutTransactionScreen;
